import { Box } from '@mui/material'
import { Modal, Button } from 'Common/Supplyvue-ui'

/** Asks before leaving a grid with unsaved edits (design system: Dialog). */
export const NavigationModal = ({
  open,
  handleCancel,
  handleProceed,
}: {
  open: boolean
  handleCancel: () => void
  handleProceed: () => void
}) => (
  <Modal
    open={open}
    handleClose={handleCancel}
    header="Discard unsaved changes?"
    size="sm"
    body={
      <Box sx={{ fontSize: 13, color: 'var(--ink-700)' }}>
        This table has edits that have not been saved. Leaving now discards
        them.
      </Box>
    }
    footer={
      <>
        <Button variant="outlined" onClick={() => handleCancel()}>
          Keep editing
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => handleProceed()}
        >
          Discard and leave
        </Button>
      </>
    }
  />
)
